export default __webpack_public_path__ + "1b510352eff366f2d649b0d0a89a5da1.png";